import { Box as MuiBox } from "@mui/material";
import { Theme } from "common";
import OISContainer from "./OISContainer";

const boxStyles = {
  marginTop: "1em",
  paddingX: "1.5em",
  backgroundColor: Theme.palette.primary.contrastText,
  boxShadow: "rgba(0, 0, 0, 0.1) 1px 1px 3px 0.2px",
};

const OISPage = () => {
  return (
    <MuiBox
      sx={{ paddingX: "1.5em", paddingY: "30px", width: "100%", minWidth: 0 }}
    >
      <MuiBox id="ois-home" sx={boxStyles}>
        <OISContainer />
      </MuiBox>
    </MuiBox>
  );
};

export default OISPage;
